import React, {Fragment} from 'react';
import {Flex, Button} from 'components';
import {capitalize, useNamedSelector} from 'helpers';

export function Upgrade({ popup }) {
  const { plan } = useNamedSelector('session.subscription');
  return (
    <Fragment>
      <h2>Get Premium!</h2>
      <p>
        You have { plan == 'Advanced' ? ' an ' : ' a ' }
        '{ capitalize(plan) }'
        account.
      </p>
      <p>For full unlimited access to all features in the Web Program, please upgrade to a 'Premium' account.</p>
      <Flex className={['spacing', 'right', 'tiny-gutter']}>
        <Button className="borderless" onClick={popup.close}>Close</Button>
        <Button className="primary" to="/settings/membership/" onClick={popup.close}>Upgrade Account</Button>
      </Flex>
    </Fragment>
  );
}
